import styled from '@emotion/styled'

import { DesktopTimePicker } from '@mui/x-date-pickers'

const StyledDateTimePicker = styled(DesktopTimePicker)`
  margin-top: 0px;
`
export default StyledDateTimePicker
